import Router from "./Router";

export default function App() {
  return <Router />;
}
